<template>
  <div>
    <template v-if="isValidAppointmentID && appointment_data_valid">
      <section>
        <ul v-if="errors.length" class="error">
          <li v-for="err in errors" :key="err">{{ err }}</li>
        </ul>

        <div v-if="!errors.length && !is_getting_data">
          <h2>We look forward <br/>to seeing you</h2>

          <h2 class="card-heading">Your Appointment Details</h2>
          <div class="card details">
            <div class="inner">
              <div class="heading">
                <img :src="'//' + currentURL + '/app/themes/leightons/images/calendar-icon-purple.svg'" width="35" />
                <h3>{{ parseServiceTitle(true) }}</h3>
              </div>
              <div class="address-details">
                <img :src="'//' + currentURL + '/app/themes/leightons/images/house-pin-icon-purple.svg'" width="32" height="36" />
                <p>
                  At <a :href="appointment.location_website" target="_blank">{{ parseLocationTitle() }}</a>

                  <template v-if="appointment.audiologist && appointment.audiologist.title && displayAudiologist">
                    with <a :href="appointment.audiologist.link" target="_blank">{{ appointment.audiologist.title }}</a>
                  </template>

                  <br>{{ parseBookingDate() }}<br>
                  <span>({{ parseBookingDuration() }} minutes appointment)</span>
                </p>
              </div>
            </div>
            <div class="button-container">
              <a class="button" :href="buildAddToCalendarUrl()" download="download"><span><CalendarClockIcon class="icon icon-fill"/><span>Add to calendar</span></span></a>
            </div>
          </div>

          <template v-if="hasNextSteps">
            <h2 class="card-heading" v-if="getNextStepsValue('title') != ''">{{getNextStepsValue('title')}}</h2>
            <div class="card next-step" v-if="getNextStepsValue('heading') != '' || getNextStepsValue('text') != ''">
              <div class="inner">
                <h3 v-if="getNextStepsValue('heading') != ''">{{ getNextStepsValue('heading') }}</h3>
                <div v-if="getNextStepsValue('text') != ''" v-html="getNextStepsValue('text')">
                </div>
              </div>
              <div class="button-container" v-if="getNextStepsValue('btnlabel') != '' && getNextStepsValue('btnurl') != ''">
                <a class="button secondary-button" :href="getNextStepsValue('btnurl')">{{getNextStepsValue('btnlabel')}}</a>
              </div>
            </div>
          </template>

          <h2 class="card-heading">Location</h2>
          <div class="card location">
            <div class="inner">
              <div style="width: 100%;height: 50vh;min-height: 460px;" class="location-map"></div>
            </div>
            <div class="button-container">
              <a class="button" :href="directionLink" target="_blank"><span><DirectionsIcon class="icon icon-stroke"/>Get directions</span></a>
            </div>
          </div>

          <h2 class="card-heading">Address &amp; Contact Details</h2>
          <div class="card address">
            <div class="inner">
              <div class="address-col">
                <p v-html="parseAddressContactDetails()"></p>
                <p class="phone-number" v-if="getLocationPhone != ''"><img :src="'//' + currentURL + '/app/themes/leightons/images/phone-icon.svg'" /><a :href="getLocationPhone">{{ appointment.location_phone }}</a></p>
              </div>
              <div class="facilities-col" v-if="getLocationFacilities.length > 0">
                  <h4>Facilities</h4>
                  <ul>
                    <li v-for="faci in getLocationFacilities" :key="faci">
                      {{ faci }}
                    </li>
                  </ul>
              </div>
            </div>
            <div class="button-wrapper" v-if="getLocationEmail != '' || getLocationWebsite != '' ">
              <a class="button secondary-button" :href="getLocationEmail" v-if="getLocationEmail != ''"><span><EmailIcon class="icon icon-grey" />Email Practice</span></a>
              <a class="button secondary-button" :href="getLocationWebsite" v-if="getLocationWebsite != ''" target="_blank"><span><WebsiteIcon class="icon icon-purple" />View website</span></a>
            </div>
            <div v-if="appointment.location_website" class="button-container">
              <a class="button" :href="appointment.location_website"><span><BranchDetailsIcon class="icon icon-stroke"/>Branch Details</span></a>
            </div>
          </div>

          <!-- <template v-if="appointment.audiologist && appointment.audiologist.title && displayAudiologist">
            <h2 class="card-heading">Meet your Audiologist</h2>
            <div class="card audiologist">
              <div class="inner">
                <div class="content-flex">
                  <div class="image-wrapper">
                      <figure>
                        <img :src="appointment.audiologist.thumbnail" width="32" height="36" />
                      </figure>
                  </div>
                  <div class="content">
                    <h3 v-if="appointment.audiologist.title">{{ appointment.audiologist.title }}</h3>
                    <h4 v-if="appointment.audiologist.roles && appointment.audiologist.roles.length">{{ appointment.audiologist.roles.join(', ') }}</h4>
                  </div>
                </div>
                <div v-if="appointment.audiologist.excerpt" class="content desc">
                  <div>
                    <p>{{ appointment.audiologist.excerpt }}</p>
                  </div>
                </div>
              </div>
              <div class="button-container">
                <a class="button secondary-button" :href="appointment.audiologist.link" target="_blank">Read More</a>
              </div>
            </div>
          </template> -->
        </div>
      </section>
    </template>

    <template v-else>
      <section>
          <div class="text_block" style="text-align: center;">
            <p>We've checked all over but couldn't find the appointment you're looking for.</p>
            <a class="button-link button" href="/" target="_self">Book Appointment</a>
          </div>
      </section>
    </template>
  </div>
</template>

<script>
/*global google*/
import svgCalendarClock from '../assets/calendar-clock.svg';
import CalendarClockIcon from '@/components/svgs/calendar-clock-icon.vue';
import DirectionsIcon from '@/components/svgs/directions-icon.vue';
import EmailIcon from '@/components/svgs/email-icon.vue';
import WebsiteIcon from '@/components/svgs/website-icon.vue';
import BranchDetailsIcon from '@/components/svgs/branch-details-icon.vue';

import { Loader } from "@googlemaps/js-api-loader";

//init gMapLoader for using GoogleMap library
const gMapLoader = new Loader({
  apiKey: window.wpGmap.gmap_api_key,
  version: "weekly",
  libraries: ["places"]
});

// const ICON_LOCATION = "/app/themes/leightons/images/leightons-map-icon.svg";
const ICON_LOCATION = "/app/themes/leightons/images/location-marker.png";
const OVERALL_ZOOM = 18;

export default {

  components: {
    CalendarClockIcon,
    DirectionsIcon,
    EmailIcon,
    WebsiteIcon,
    BranchDetailsIcon
  },
  created() {
    console.log(svgCalendarClock);

    this.currentURL = location.host;
  },

  data () {
    return {
      /*{
        "timeslot_id": "c9e0f59c-90c4-4494-a379-37e6950de8c5",
        "timeslot_value": "Saturday 12 November;09:00 am",
        "timeslot_calendar_value": "2022-11-12 10:30:00",
        "service_id": "Full Hearing Assessment",
        "service_value": "FHA;Full Hearing Assessment",
        "location_id": "008",
        "location_value": "Cobham;Holly Parade, Cobham KT11, UK;90",
        "location_latlng": "51.3282361,-0.4108008",
        "location_url": "https://hearing-care-partnership.lndo.site/practices/cobham/",
        "location_email": "cobham@leightons.co.uk",
        "location_website": "",
        "location_phone": "01932 867890",
        "firstname": "John",
        "lastname": "Doe",
        "dob": "2-8-1990",
        "email": "johndoe@test.com",
        "phone": "0999222333",
        "message": "how are you doing ???",
        "receiveupdateby": "email,post",
        "audiologist": {},
        "location_address_details":[],
        "location_facilities":[],
      }*/
      appointment: null,
      appointment_id: null,
      appointment_data_valid: true,
      is_getting_data: true,
      directionLink: "",
      errors: [],
      currentURL: "",
      bookingConfigs: null,

      displayAudiologist: false,//FALSE temporarily remove the display of the audiologist/clinician the appointment is apparently with, set to TRUE to display
    }
  },
  methods: {
    /* Check if string is valid UUID - REF: https://melvingeorge.me/blog/check-if-string-valid-uuid-regex-javascript */
    checkIfValidUUID(str) {
      // Regular expression to check if string is a valid UUID
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

      return regexExp.test(str);
    },

    getBookingDetail() {
      this.axios.post(`/wp-json/leightons/v1/booking-confirmation`, { timeslot_id: this.appointment_id })
        .then((response) => {
          if (response.data.configuration && response.data.appointment) {
            this.bookingConfigs = response.data.configuration;
            this.appointment = response.data.appointment;

            if (this.appointment.location_latlng) {
              setTimeout(() => {
                this.renderLocationMap();
              }, 1000);
            }

            this.addToGTMDataLayer();
          } else {
            this.errors.push('Appointment Not Found!')
            this.appointment_data_valid = false;
          }
        }).catch(() => {
          this.appointment_data_valid = false;
        })
        .finally(() => {
          this.is_getting_data = false;
        });
    },

    parseAddressContactDetails(join_seperator = "<br>") {
      let details = [];
      if (this.appointment.location_address_details && this.appointment.location_address_details.length > 0) {
        details = this.appointment.location_address_details.filter((item) => item !== "");
      }
      if (details.length == 0) {
        const [name,address,] = this.appointment.location_value.split(";");
        details = ["Leightons Opticians & Hearing Care"];
        details = details.concat(address.split(","));
      }

      if (!join_seperator) {
        join_seperator = "<br>";
      }
      return details.join(join_seperator);
    },

    parseServiceTitle(priceIncluded = false, priceOnly = false) {
      let [,title,price] = this.appointment.service_value.split(";");
      if (priceIncluded && price && price != "") {
        price = price.replace(/u00a3/i, '£');
        title = `${title} (${price})`;
      }
      if (priceOnly) {
        if (price && price != "") {
          price = price.replace(/u00a3/i, '£');
          return price;
        }
        return "";
      }
      return title;
    },

    parseLocationTitle() {
      const [title,,] = this.appointment.location_value.split(";");
      return title;
    },

    parseLocationAddress() {
      const [,address,] = this.appointment.location_value.split(";");
      return address;
    },

    parseBookingDate() {
      const [date,time] = this.appointment.timeslot_value.split(";");
      return `${date}, ${time}`;
    },

    parseBookingDuration() {
      const [,,duration] = this.appointment.location_value.split(";");
      return duration;
    },

    buildAddToCalendarUrl() {
      return `/wp-json/leightons/v1/download-appointment?appointment_id=${this.appointment_id}`;
    },

    renderLocationMap() {
      const thisView = this;
      const element = document.querySelector(".location-map");
      const [lat,lng] = this.appointment.location_latlng.split(",");
      const locationPoint = {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        };
      const mapOptions = {
        center: locationPoint,
        zoom: OVERALL_ZOOM,
        disableDefaultUI: true,
        styles: [
          {
            "featureType":"water",
            "elementType":"geometry",
            "stylers":[
              {
                "color":"#e9e9e9"
              },
              {
                "lightness":17
              }
            ]
          },
          {
            "featureType":"landscape",
            "elementType":"geometry",
            "stylers":[
              {
                "color":"#f5f5f5"
              },
              {
                "lightness":20
              }
            ]
          },
          {
            "featureType":"road.highway",
            "elementType":"geometry.fill",
            "stylers":[
              {
                "color":"#ffffff"
              },
              {
                "lightness":17
              }
            ]
          },
          {
            "featureType":"road.highway",
            "elementType":"geometry.stroke",
            "stylers":[
              {
                "color":"#ffffff"
              },
              {
                "lightness":29
              },
              {
                "weight":0.2
              }
            ]
          },
          {
            "featureType":"road.arterial",
            "elementType":"geometry",
            "stylers":[
              {
                "color":"#ffffff"
              },
              {
                "lightness":18
              }
            ]
          },
          {
            "featureType":"road.local",
            "elementType":"geometry",
            "stylers":[
              {
                "color":"#ffffff"
              },
              {
                "lightness":16
              }
            ]
          },
          {
            "featureType":"poi",
            "elementType":"geometry",
            "stylers":[
              {
                "color":"#f5f5f5"
              },
              {
                "lightness":21
              }
            ]
          },
          {
            "featureType":"poi.park",
            "elementType":"geometry",
            "stylers":[
              {
                "color":"#dedede"
              },
              {
                "lightness":21
              }
            ]
          },
          {
            "elementType":"labels.text.stroke",
            "stylers":[
              {
                "visibility":"on"
              },
              {
                "color":"#ffffff"
              },
              {
                "lightness":16
              }
            ]
          },
          {
            "elementType":"labels.text.fill",
            "stylers":[
              {
                "saturation":36
              },
              {
                "color":"#333333"
              },
              {
                "lightness":40
              }
            ]
          },
          {
            "featureType":"transit",
            "elementType":"geometry",
            "stylers":[
              {
                "color":"#f2f2f2"
              },
              {
                "lightness":19
              }
            ]
          },
          {
            "featureType":"administrative",
            "elementType":"geometry.fill",
            "stylers":[
              {
                "color":"#fefefe"
              },
              {
                "lightness":20
              }
            ]
          },
          {
            "featureType":"administrative",
            "elementType":"geometry.stroke",
            "stylers":[
              {
                "color":"#fefefe"
              },
              {
                "lightness":17
              },
              {
                "weight":1.2
              }
            ]
          }
        ]
      };

      gMapLoader.load()
        .then(() => {

          let map = new google.maps.Map(element, mapOptions);
          new google.maps.Marker({
              position: locationPoint,
              map,
              icon: ICON_LOCATION,
            });
        });

        thisView.directionLink = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    },

    getNextStepsValue(field) {
      if ( this.bookingConfigs && this.appointment && this.appointment.service_id) {
        const next_step_of_current_services = this.bookingConfigs.nextsteps.filter(item => this.htmlDecode(item.service_id) === this.htmlDecode(this.appointment.service_id));
        if (next_step_of_current_services && next_step_of_current_services.length > 0) {
          const next_step_of_current_service = next_step_of_current_services[0];
          const b_field = `booking_nextsteps_${field}`;
          return next_step_of_current_service[b_field];
        }
      }
      return "";
    },

    htmlDecode(input){
      const e = document.createElement('textarea');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    },

    addToGTMDataLayer() {
      const price = this.parseServiceTitle(false, true);
      //if (price !== "") {
        //price = this.htmlDecode(price);
      //}
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'eec.purchase',
        'ecommerce': {
          'currencyCode': 'GBP',
          'purchase': {
            'actionField': {
                'id': this.appointment_id,
                'revenue': price,
                'tax': '0',
                'shipping': '0'
            },
            'products':[{
              'name': this.parseServiceTitle(false, false),
              'id': this.appointment.service_id,
              'price': price,
              'quantity': 1,
              'brand': 'Leightons Opticians & Hearing Care',
              'category': 'Hearing Services'
            }]
          }
        }
      });
    }

  },
  mounted () {
    this.appointment_id = this.$route.params['appointment'];

    if (this.isValidAppointmentID) {
      this.getBookingDetail();
    } else {
      this.is_getting_data = false;
    }
    window.scrollTo(0, 0);
  },
  computed: {
    isValidAppointmentID() {
      return this.checkIfValidUUID(this.appointment_id);
    },
    getLocationPhone() {
      if (this.appointment.location_phone && this.appointment.location_phone != "") {
        return "tel:" + this.appointment.location_phone.replaceAll(" ", "");
      }
      return "";
    },
    getLocationEmail() {
      if (this.appointment.location_email && this.appointment.location_email != "") {
        return "mailto:" + this.appointment.location_email;
      }
      return "";
    },
    getLocationWebsite() {
      return this.appointment.location_website ?? '';
    },
    getLocationFacilities() {
      if ( this.appointment.location_facilities &&  this.appointment.location_facilities.length > 0) {
        return this.appointment.location_facilities.filter((item) => item.trim() !== "");
      }
      return [];
    },

    hasNextSteps() {
      if ( this.bookingConfigs && this.appointment && this.appointment.service_id) {
        const next_step_of_current_services = this.bookingConfigs.nextsteps.filter(item => this.htmlDecode(item.service_id) === this.htmlDecode(this.appointment.service_id));
        if (next_step_of_current_services && next_step_of_current_services.length > 0) {
          const next_step_of_current_service = next_step_of_current_services[0];
          return (next_step_of_current_service.booking_nextsteps_title != "" ||
                next_step_of_current_service.booking_nextsteps_heading != "" ||
                next_step_of_current_service.booking_nextsteps_text != "" ||
              (next_step_of_current_service.booking_nextsteps_btnlabel != "" && next_step_of_current_service.booking_nextsteps_btnurl != "" ));
        }
      }
      return false;
    },
  },
}
</script>

<style lang="postcss" scoped>
div {

  .heading-container {
    @apply flex justify-center bg-white p-7;

    img:first-of-type {
      @apply mr-[30px];
    }

    img:last-of-type {
      @apply ml-[30px];
    }
  }
  .heading {
    @apply pt-[8px] text-center tracking-wider leading-[32px] sm:leading-normal text-[30px] sm:text-[40px] uppercase;

    .line-break::after{
      @apply whitespace-pre sm:whitespace-normal;

      content: "\a";
    }
  }
}

section {
  @apply pt-[45px] pb-[70px] sm:pb-[130px] w-full sm:w-[630px] mx-auto px-[30px] sm:px-0;

  h2 {
    @apply text-[25px] leading-[25px] md:text-[35px] md:leading-[35px] text-center border-b border-purple-darker pb-8 sm:pb-9 mb-[25px] md:mb-[35px];

    &.card-heading {
      @apply md:text-[30px] md:leading-[35px] border-0 text-left mb-6 md:mb-7 pb-0 text-purple-darker;
    }
  }

  .card {

    @apply relative bg-white drop-shadow-lg rounded-xl w-full mb-[25px] md:mb-[36px] overflow-hidden;

    .inner {
      @apply py-[30px] px-5 sm:py-[30px] sm:px-10;

      p {
        @apply font-avenir-book text-base leading-[22px];
      }
    }

    .button-wrapper {
      @apply flex flex-col md:flex-row pt-0 pb-[30px] px-5 md:px-10 items-center;

      .button {
        @apply h-[50px] rounded-full;

        &:hover .icon-grey, &:hover .icon-purple {
          @apply stroke-white;
        }

        span {
          @apply flex flex-row items-center justify-center;

          img, .icon {
            @apply mr-[6px] max-h-[19px] -mt-[1px];
          }

          .icon-grey {
            @apply stroke-[#55565a];
            fill: none;
          }

          .icon-purple {
            @apply stroke-purple-darker;
            fill: none;
          }
        }

        & + .button {
          @apply md:ml-4;
        }

      }
    }

    .button-container {
      @apply py-[30px] px-5 md:py-[30px] md:px-10 bg-[#F2FCFC];

      .button {
        @apply rounded-none h-[50px];

        .icon-fill {
          @apply fill-white;
        }

        .icon-stroke {
          @apply stroke-white;
        }

        &:hover .icon-fill {
          @apply fill-purple-darker;
        }

        &:hover .icon-stroke {
          @apply stroke-purple-darker;
        }

        span {
          @apply flex flex-row items-center justify-center;

          img, .icon {
            @apply mr-[6px] max-h-[19px];

          }
        }

      }
    }

    &.details {

      .heading {
        @apply border-b border-navy border-opacity-20 mb-[20px] pb-[20px] items-center flex justify-start pt-0;

        h3 {
          @apply text-left text-[18px] sm:text-[22px] uppercase font-brandon-black mb-0;
        }

        img {
          @apply h-[36px] mr-[15px];
        }
      }

      .address-details {
        @apply w-[80%] flex flex-row items-start;

        img {
          @apply mr-4;
        }

        p {

          a  {
            @apply text-pink underline hover:no-underline;
          }

          span {
            @apply text-[#446481];
          }
        }
      }

      .button-container {
        .button {
          @apply rounded-none;
        }
      }
    }

    &.location {

      .inner {
        @apply p-0;
      }
    }

    &.address {

      .inner {
        @apply flex flex-row;

        .phone-number {
          @apply flex flex-row mt-4;

          img {
            @apply mr-2;
          }
        }
      }

      .address-col, .facilities-col {
        @apply flex-col mb-0 w-1/2;
      }

      ul {
        @apply list-disc;

        li {

          &::marker {
            @apply text-aqua-darker;
          }
        }
      }

      ol {
        @apply list-decimal;
      }

      ul, ol {

        @apply mb-[20px] pl-[15px];

        li {
          @apply list-outside;

          a {
            @apply hover:underline;
          }
        }
      }

      .facilities-col {

        h4 {
          @apply text-base font-avenir-medium tracking-widest mb-2 uppercase;
        }
      }
    }

    &.audiologist {

      h3 {
        @apply font-brandon-black text-[26px] text-navy uppercase tracking-wide mb-1;
      }

      h4 {
        @apply font-avenir-medium text-base text-navy tracking-wide uppercase;
      }

      p {
        @apply font-avenir-book text-charcoal text-base;
      }

      .content-flex {
        @apply flex flex-row items-center;
      }

      .content {
        @apply !pl-[18px];

        &.desc {
          @apply !pl-0  md:!pl-[78px] mt-5;
        }
      }

      .button-container-white {
        @apply static !py-8 !px-10;
      }

      .image-wrapper {
        @apply !w-[60px] !h-[60px] !rounded-full overflow-hidden relative !border-0;

        &:after {
          content: "";
          @apply block absolute top-0 left-0 h-full w-full rounded-full border-4 border-[#6DC4C4];
        }

        figure {
          @apply absolute h-full w-full;

          img {
            @apply w-full h-full object-cover;
          }
        }
      }
    }

    &.next-step {

      .inner {

        >>> p {
          @apply mb-4 last:mb-0;
        }
      }
    }
  }
}
/* }
section {
  @apply pt-[45px] pb-[70px] sm:pb-[130px] w-full sm:w-[630px] mx-auto px-[30px] sm:px-0;

  div {
    div {
      @apply relative bg-white drop-shadow-lg rounded-xl w-full p-[15px] sm:p-[35px] mb-[20px];
    }

    .button-container-white {
      @apply flex absolute bottom-0 left-0 bg-[#F2FCFC] m-0;

      border-radius: 0.75rem !important;
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;

      .button {
        @apply w-full sm:w-auto justify-center flex text-pink text-[12px] uppercase font-bold tracking-widest rounded-full px-[10px] sm:px-[50px] py-[15px] border border-pink;
      }
    }

    @media (min-width: 640px) {
      .button-container-white {
        padding: 25px 30px !important;
      }
      .button-container {
        padding: 25px 30px !important;
      }
    }

    @media (max-width: 639px) {
      .button-container-white {
        padding: 25px 15px !important;
      }
      .button-container {
        padding: 25px 15px !important;
      }
    }

    .button-container {
      @apply flex absolute bottom-0 left-0 bg-[#F2FCFC] m-0;

      border-radius: 0.75rem !important;
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;

      .button {
        @apply w-full sm:w-auto justify-center flex text-white text-[12px] uppercase font-bold tracking-widest bg-pink rounded-full px-[10px] sm:px-[50px] py-[15px];

        img {
          @apply w-[22px] h-[19px] mr-[10px];
        }
      }
    }


    .next-step {
      @apply h-[360px];

      h3 {
        @apply text-[18px] sm:text-[22px] uppercase font-brandon-black mb-[10px];
      }

      .button {
        @apply px-[30px];
      }
    }

    .location {
      @apply p-0;
    }

    .audiologist {

      @apply p-0 overflow-hidden !mb-0;

      div {
        @apply !rounded-none !p-0 !mb-0;
        filter: drop-shadow(0 0 0) !important;
      }

      .inner {
        @apply !p-[35px];
      }

      h3 {
        @apply font-brandon-black text-[26px] text-navy uppercase tracking-wide;
      }

      h4 {
        @apply font-avenir-medium text-base text-navy tracking-wide uppercase;
      }

      p {
        @apply font-avenir-book text-charcoal text-base;
      }

      .content-flex {
        @apply flex flex-row items-start;
      }

      .content {
        @apply !pl-[18px];

        &.desc {
          @apply !pl-0  md:!pl-[78px] mt-5;
        }
      }

      .button-container-white {
        @apply static !py-8 !px-10;
      }

      .image-wrapper {
        @apply !w-[68px] !h-[60px] !rounded-full overflow-hidden relative grow !border-0;

        &:after {
          content: "";
          @apply block absolute top-0 left-0 h-full w-full rounded-full border-4 border-[#6DC4C4];
        }

        figure {
          @apply absolute h-full w-full;

          img {
            @apply w-full h-full object-cover;
          }
        }
      }
    }

    .address {
      @apply mb-0 px-0 pb-0;

      .address-col, .facilities-col {
        @apply flex-col mb-0;
      }

      ul {
        @apply list-disc;

        li {

          &::marker {
            @apply text-aqua-darker;
          }
        }
      }

      ol {
        @apply list-decimal;
      }

      ul, ol {

        @apply mb-[20px] pl-[15px];

        li {
          @apply list-outside;

          a {
            @apply hover:underline;
          }
        }
      }

      .facilities-col {

        h4 {
          @apply text-base font-avenir-medium tracking-widest mb-2 uppercase;
        }
      }

      div {
        @apply flex justify-start drop-shadow-none p-0 rounded-none;
      }

      > div {
        @apply px-[15px] sm:px-[35px];
      }


      .button-wrapper {
        @apply block sm:flex m-0 px-[15px] sm:px-[35px] pb-[20px];

        .button {
          @apply mb-[20px] sm:mb-0 w-full sm:w-auto justify-center flex text-pink text-[12px] leading-relaxed uppercase font-bold tracking-widest rounded-full px-[10px] sm:px-[50px] py-[15px] border border-pink;

          img {
            @apply mr-[10px];
          }
        }

        .button:first-of-type {
          @apply mr-[20px];

          img {
            @apply h-[14px] mt-[2px];
          }
        }

        .button:last-of-type {

          img {
            @apply h-[22px] w-[22px];
          }
        }
      }

      .phone-number {
        @apply flex my-[30px] leading-tight;

        img {
          @apply w-[17px] h-[17px] mr-[10px];
        }
      }

      .button-container {

        @apply relative;

        .button {
          @apply leading-relaxed;
        }
        img {
          @apply w-[19px] h-[22px];
        }
      }
    }

  }

  .text_block {
    @apply h-[330px] text-center;
  }
} */
</style>